import { useState, useEffect } from 'react';

/**
 * Custom hook to detect if the current viewport is mobile (< 768px)
 * Uses window.matchMedia for efficient responsive detection
 * @returns {boolean} true if viewport width is less than 768px
 */
export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Create media query for mobile breakpoint (matches Tailwind's md: breakpoint)
    const mediaQuery = window.matchMedia('(max-width: 767px)');

    // Set initial value
    setIsMobile(mediaQuery.matches);

    // Handler for media query changes
    const handleChange = (e) => {
      setIsMobile(e.matches);
    };

    // Listen for changes
    mediaQuery.addEventListener('change', handleChange);

    // Cleanup
    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, []);

  return isMobile;
}
